import React, { useState } from 'react';
import CloseIcon from '@material-ui/icons/HighlightOff';
import { useHistory } from 'react-router-dom';

import { RemoveItemModal } from 'components/modals';
import { getItemPriceDisplay } from 'utils/helpers';

import {
  RmaDetailTitle,
  RmaItem,
  SerialNumber,
  RmaInfo,
  RmaItemListStyled,
} from './styledComponents';
import { useFormatPrice } from 'utils/hooks/useFormatPrice';

export const RmaItemList = ({ caseNumber, items = [], isCheckoutPage, currencyCode }) => {
  const [isRemoveItemModalOpen, setIsRemoveItemModalOpen] = useState(false);
  const [itemToRemove, setItemToRemove] = useState(null);
  const history = useHistory();
  const formatPrice = useFormatPrice();

  return (
    <>
      <RmaDetailTitle onClick={() => history.push('/cases/new/details')}>RMA Detail</RmaDetailTitle>
      <RmaItemListStyled>
        {items.map((item) => {
          return (
            <RmaItem key={item.serialNumber}>
              <SerialNumber>{item.serialNumber}</SerialNumber>
              {!isCheckoutPage && (
                <CloseIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    setItemToRemove(item);
                    setIsRemoveItemModalOpen(true);
                  }}
                />
              )}
              <RmaInfo>
                <span>{item.partNumber}</span>
                <span>{getItemPriceDisplay(item, formatPrice, currencyCode)}</span>
              </RmaInfo>
            </RmaItem>
          );
        })}
      </RmaItemListStyled>
      <RemoveItemModal
        isOpen={isRemoveItemModalOpen}
        item={itemToRemove}
        onClose={() => setIsRemoveItemModalOpen(false)}
        onClick={(e) => {
          e.stopPropagation();
          e.nativeEvent.stopImmediatePropagation();
        }}
      />
    </>
  );
};
